const CrmProjectType = {
  Type2d: 0,
  Type3d: 1,
};

export { CrmProjectType };
